import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ValidacionBeneficiarioService } from "../validadores/validacionBeneficiario.service";
import { ValidacionConyugeService } from "../validadores/validacionConyuge.service";
import { ValidacionTrabajadorService } from "../validadores/validacionTrabajador.service";

@Injectable({
  providedIn: "root",
})
export class ValidacionesFormularioService {
  constructor(
    private validacionTrabajador: ValidacionTrabajadorService,
    private validacionConyuge: ValidacionConyugeService,
    private validacionBeneficiario: ValidacionBeneficiarioService
  ) {}

  validarTrabajador(form: FormGroup): void {
    this.validacionTrabajador.validar(form);
  }

  validarConyuge(form: FormGroup): void {
    this.validacionConyuge.validar(form);
  }

  validarParentescoBeneficiario(form: FormGroup): void {
    this.validacionBeneficiario.validar(form);
  }

  getIndexUltimoBeneficiario(form: FormGroup): number {
    return this.validacionBeneficiario.getIndexUltimoBeneficiario(form);
  }
}
